import { render, staticRenderFns } from "./BxSelect.vue?vue&type=template&id=f773b414&"
import script from "./BxSelect.vue?vue&type=script&lang=js&"
export * from "./BxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports